const globalConfig = {
    // baseUrl: http://192.168.3.6:9080 http://192.168.3.6:9081
    baseUrl: process.env.NODE_ENV === "development" ? "http://192.168.3.6:9082" : "https://api2.bm2500.com",
    // 推广域名
    promotionDomain: "https://s.bm2500.com",
}



export default globalConfig